(function () {
    "use strict";

    function storage($window) {

        // Set here wich store (local or session) to use
        var store = $window.localStorage;

        var vm = this;

        vm.add = add;
        vm.get = get;
        vm.remove = remove;

        function add(key, value) {
            value = angular.toJson(value);
            store.setItem(key, value);
        }

        function get(key) {
            var value = store.getItem(key);
            if (value) {
                value = angular.fromJson(value);
            }
            return value;
        }

        function remove(key) {
            store.removeItem(key);
        }
    }

    storage.$inject = ["$window"];

    angular.module("sphForms.auth").service("sphForms.storage", storage);

})();